export enum FilterPredicate {
    Sport,
    Date,
    LiveStreaming,
    Favorites
}

export enum SubFilterPredicate {
    None,
    LiveStreaming,
    FastMarket
}